<script>
import {defineComponent} from 'vue'
import {mapGetters, mapState} from "vuex";
import i18n from "@/i18n";
import draggable from "vuedraggable";
import { flattenEstablishmentContacts } from "@/composables/clientPickerShared";

export default defineComponent({
  name: "EstablishmentContact",
  components: { draggable },
  props: {
    isThirdAccount: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      /*
				 * we call estaContact an establishment contact to distinct from contact which is a supplier or customer
				 *
				 * */
      blank_estaContact: {
        // blank establishment contact sent on save document
        id: 0,
        email: "",
        job: "",
        name: "",
        phone: ""
      },
      without_estaContact: {
        id: null,
        email: "",
        job: "",
        name: "",
        phone: ""
      },
    }
  },
  computed: {
    ...mapState({
      appId: state => state.app.id,
      rights: state => state.app.rights,
    }),
    contactInfos: {
      get() {
        return this.isThirdAccount ? this.$store.state.contacts.thirdAccount : this.$store.state.contacts.contactInfos;
      },
      set(value) {
        this.isThirdAccount ? this.$store.commit("thirdAccount", value) : this.$store.commit("contactInfos", value);
      }
    },
    contactInfos_establishments_contacts() {
      if (!this.contactInfos || !this.contactInfos.establishments)
        return []
      return flattenEstablishmentContacts(this.contactInfos.establishments);
    },
    selectedEstaContact: {
      get() {
        let _by_id = undefined;
        let _by_contact_info = undefined;

        if (!this.contactInfos) return this.blank_estaContact;

        if (
            (this.contactInfos.establishment_contact_id === undefined) &&
            !this.contactInfos_establishments_contacts.length
        ) {
          return Object.assign(this.blank_estaContact, { establishment: this.contactInfos.establishments[0] });
        }

        // on load
        if (
            (this.contactInfos.establishment_contact_id === undefined || this.contactInfos.establishment_contact_id === 0) &&
            this.contactInfos_establishments_contacts.length
        ) {
          //_by_id = this.selectedEstablishment.contacts.find(c => c.id === this.contactInfos.establishment_contact.id);
          //if (_by_id !== undefined)
          //return _by_id;
          // retro compatibility
          _by_contact_info = this.contactInfos_establishments_contacts.find(
              c => c.email === this.contactInfos.email
          );
          return _by_contact_info !== undefined ? _by_contact_info : this.contactInfos_establishments_contacts[0];
        }

        // user added a contact
        if (this.contactInfos.establishment_contact_id === 0) return Object.assign(this.blank_estaContact, { establishment: this.contactInfos.establishments[0] });

        // user did select a contact
        if (this.contactInfos.establishment_contact_id > 0) {
          _by_id = this.contactInfos_establishments_contacts.find(
              c => c.id === this.contactInfos.establishment_contact_id
          );
          return _by_id !== undefined ? _by_id : this.contactInfos_establishments_contacts[0];
        }

        return this.without_estaContact;
      },
      set(newEstaContact) {
        this.handleSelectEstablishmentContactChange(newEstaContact);
      }
    },
    isThirdAccountGlobal: {
      get() {
        return this.$store.state.contacts.isThirdAccountGlobal;
      },
      set(value) {
        this.$store.commit("isThirdAccountGlobal", value);
      }
    },
    showEditEstablishmentContactModal: {
      get() {
        return this.$store.state.home.showEditEstablishmentContactModal;
      },
      set(value) {
        this.$store.commit("showEditEstablishmentContactModal", value);
      }
    },
    establishment() {
      if (!this.contactInfos.establishment_id) {
        return null;
      }
      return this.contactInfos.establishments.find(
          e => e.id === this.contactInfos.establishment_id
      ) ?? null;
    }
  },
  watch: {
    // as selectedEstaContact is a computed property, we need to watch it to handle changes on it's getter
    // to update contactInfos.email and contactInfos.establishment_contact_id
    selectedEstaContact: {
      handler(newVal, oldVal) {
        if (newVal && newVal.id !== oldVal?.id) {
          this.handleSelectEstablishmentContactChange(newVal);
        }
      },
      deep: true,
      immediate: true
    },
    'contactInfos.details_tags': {
      handler(newVal) {
        if (!newVal || newVal.length === 0) {
          this.contactInfos.details = null;
        }
        else {
          this.contactInfos.details = (newVal).join('&nbsp;');
        }
      },
      deep: true
    },
    'contactInfos.phone_tags': {
      handler(newVal) {
        if (!newVal || newVal.length === 0) {
          this.contactInfos.phone = null;
        }
        else {
          this.contactInfos.phone = (newVal).join('&nbsp;');
        }
      },
      deep: true
    }
  },
  methods: {
    handleSelectEstablishmentContactChange(newEstaContact) {
      const _contactInfos = JSON.parse(JSON.stringify(this.contactInfos));
      _contactInfos.email = newEstaContact.email ?? "";
      _contactInfos.phone = newEstaContact.phone ?? "";
      _contactInfos.phone_tags = [newEstaContact.phone?.trim()].filter(info => info && info.length > 0);
      _contactInfos.establishment_contact_id = newEstaContact.id;
      _contactInfos.details_tags = [newEstaContact.name?.trim(), newEstaContact.job?.trim()].filter(info => info && info.length > 0);
      _contactInfos.details = _contactInfos.details_tags.join("&nbsp;");
      this.contactInfos = Object.assign({}, {..._contactInfos});
      // update recurring recipients.main
      this.$store.commit("updateRecipientProperty", {
        property: "main",
        value: this.contactInfos.email ?? ""
      });
      // synchronize recurring recipients
      this.$nextTick(() => {
        this.$store.commit(
            "initRecipientEmailsFromContactInfosEstablishments",
            this.contactInfos.establishments ?? []
        );
      });
    },
    addBlankEstaContact() {
      this.selectedEstaContact = this.blank_estaContact;
      // open modal
      this.showModalEditEstablishmentContact(Object.assign({establishment: this.establishment}, {...this.blank_estaContact}))
    },
    setNoEstaContact() {
      this.selectedEstaContact = Object.assign({}, this.without_estaContact);
    },
    onEstaContactChange(contact) {
      this.selectedEstaContact = contact;
    },
    showModalEditEstablishmentContact(estaContact) {
      this.isThirdAccountGlobal = this.isThirdAccount;
      // local contact management
      if (this.eventContact !== true) {
        this.$store.commit("editableEstablishmentContact", estaContact);
        this.$store.commit("showEditEstablishmentContactModal", true);
      }
      else { // app contact management
        this.dispatchEvent({
          modalName: null,
          source: "billing",
          action: "edit_establishment_contact",
          data: estaContact
        });
      }
    },
    isEmptyContact() {
      return this.selectedEstaContact.id === 0 || this.selectedEstaContact.id === null;
    }
  }
})
</script>

<template>
  <b-container>
    <b-row align-v="start">
      <b-col cols="9" v-if="isEmptyContact()">
        <!-- establishment contact creation mode -->
        <div
            v-if="selectedEstaContact.id === 0 && ((rights?.includes('!app.contacts.create') ? false : true) ?? true)"
            class="btn-link"
            style="cursor: pointer"
            @click="showModalEditEstablishmentContact(Object.assign({establishment: establishment}, {...selectedEstaContact}))"
        >
          {{ $t("Aucun email associé") }}
        </div>
        <div
            v-else-if="selectedEstaContact.id === 0 && !rights?.includes('!app.contacts.create')"
            class="text-muted italic"
        >
          {{ $t("Aucun email associé") }}
        </div>

        <div
            v-else-if="selectedEstaContact.id === null"
            class="text-muted italic"
        >
          {{ $t("Ne pas associer de destinataire") }}
        </div>

      </b-col>
      <b-col cols="9" v-else>
        <!-- establishment contact selection mode -->
        <div>
          <b-form-tags
              input-id="tags-details"
              v-model="contactInfos.details_tags"
              size="md"
              add-button-text=""
              placeholder=""
              tag-class="bg-transparent text-body"
              style="border:0; padding:0"
              no-outer-focus
          >
            <template #default="{ tags, inputAttrs, inputHandlers, addTag, removeTag }">
              <draggable
                  :value="contactInfos.details_tags"
                  @input="val => contactInfos.details_tags = val"
                  class="d-flex flex-wrap align-items-center draggable-tags"
                  ghost-class="drag-ghost"
                  handle=".drag-handle"
              >
                <span
                    v-for="tag in tags"
                    :key="tag"
                    class="d-inline-flex align-items-center mr-1 mb-1 tag-badge drag-handle small font-weight-normal"
                    style="font-size: 13px"
                >
                  {{ tag }}
                  <b-button
                      size="sm"
                      variant="link"
                      class="p-0 ml-1 text-muted"
                      @click="removeTag(tag)"
                      aria-label="Remove tag"
                  >
                    &times;
                  </b-button>
                </span>
              </draggable>
            </template>
          </b-form-tags>
        </div>
        <div>
          <b-form-tags
              input-id="tags-phone"
              v-model="contactInfos.phone_tags"
              size="md"
              add-button-text=""
              placeholder=""
              tag-class="bg-transparent text-body"
              style="border:0; padding:0"
              no-outer-focus
          >
            <template #default="{ tags, inputAttrs, inputHandlers, addTag, removeTag }">
              <span
                  v-for="tag in tags"
                  :key="tag"
                  class="d-inline-flex align-items-center mr-1 mb-1 tag-badge drag-handle small font-weight-normal"
                  style="font-size: 13px"
              >
                {{ tag }}
                <b-button
                    size="sm"
                    variant="link"
                    class="p-0 ml-1 text-muted"
                    @click="removeTag(tag)"
                    aria-label="Remove tag"
                >
                  &times;
                </b-button>
              </span>
            </template>
          </b-form-tags>
        </div>
        <div>{{ selectedEstaContact.email }}</div>
        <!--div
            v-if="!selectedEstaContact.name && !selectedEstaContact.email"
            class="italic text-muted"
            style="color: #6c757d"
        >
        </div-->
      </b-col>
      <b-col v-if="(rights?.includes('!app.contacts.create') ? false : true) ?? true" cols="3">
        <b-row>
          <b-col cols="6">
            <!-- select Establishment Contact -->
            <b-dropdown
                id="('destinataire' + isThirdAccount ? '_third': '')"
                size="xs"
                :text="$t('Dest.')"
                class="mt-0"
                variant="light"
                style="border: 1px solid var(--border); border-radius: 5px; min-width: 70px"
            >
              <b-dropdown-item
                  v-for="estaContact in contactInfos_establishments_contacts"
                  :key="`c_${estaContact.id}`"
              >
                <b-row>
                  <b-col
                      cols="11"
                      @click="onEstaContactChange(estaContact)"
                  >
                    <div class="establishment-details">
                      <span>
                        {{
                          (estaContact.name
                              ? estaContact.name
                              : "") +
                          (estaContact.job ? " - " : " ") +
                          (estaContact.job
                              ? estaContact.job
                              : "") +
                          (estaContact.email ? " - " : " ") +
                          (estaContact.email
                              ? estaContact.email
                              : "")
                        }}
                      </span>
                      <br />
                      <span class="text-gray">
                        {{ estaContact.establishment.name }}
                      </span>
                    </div>
                  </b-col>
                  <b-col cols="1" class="p-0 m-0">
                    <b-icon
                        @click="
                          showModalEditEstablishmentContact(Object.assign({establishment: estaContact.establishment}, {...estaContact}))"
                        icon="pencil"
                        style="height: 17px; width: 17px;"
                    />
                  </b-col>
                </b-row>
              </b-dropdown-item>

              <!-- item ne pas selectionner un estacontact -->
              <b-dropdown-item
                  v-if="contactInfos_establishments_contacts.length"
                  class="text-center"
              >
                <b-button
                    variant="link"
                    class="establishment-details"
                    @click="setNoEstaContact"
                >
                  {{ $t("Ne pas associer de destinataire") }}
                </b-button>
              </b-dropdown-item>

              <!-- item ajouter un estacontact -->
              <b-dropdown-item class="text-center">
                <b-button
                    variant="link"
                    class="establishment-details"
                    @click="addBlankEstaContact"
                >
                  {{ $t("Nouveau destinataire") }}
                </b-button>
              </b-dropdown-item>
            </b-dropdown>
            <b-tooltip placement="top" :target="('destinataire' + isThirdAccount ? '_third': '')" container="body">
              {{ $t("Destinataire") }}
            </b-tooltip>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-container>

</template>

<style scoped lang="scss">
.draggable-tags {
  gap: 2px;
}
.tag-badge {
  cursor: grab;
  user-select: none;
  font-size: 0.85em;
  &:active {
    cursor: grabbing;
  }
}
.drag-ghost {
  opacity: 0.4;
}
.tag-input {
  outline: none;
  border: none;
  font-size: 0.8rem;
  width: 20px;
  transition: width 0.2s ease;
  &:focus {
    width: 120px;
  }
}
</style>
